import 'core-js/fn/object/assign';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './Root';

ReactDOM.render(
    <Root />, document.getElementById('root'));



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/